import { render } from "./Inscriptos.vue?vue&type=template&id=5425665d"
import script from "./Inscriptos.vue?vue&type=script&lang=js"
export * from "./Inscriptos.vue?vue&type=script&lang=js"

import "./Inscriptos.vue?vue&type=style&index=0&id=5425665d&lang=css"

import exportComponent from "/home/runner/work/backoffice-base-vue3/backoffice-base-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__